var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaretDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.335 4.50011C10.335 4.59511 10.3 4.69011 10.225 4.76511L6.96501 8.02511C6.43501 8.55511 5.56501 8.55511 5.03501 8.02511L1.77501 4.76511C1.63001 4.62011 1.63001 4.38011 1.77501 4.23511C1.92001 4.09011 2.16001 4.09011 2.30501 4.23511L5.56501 7.49511C5.80501 7.73511 6.19501 7.73511 6.43501 7.49511L9.69501 4.23511C9.84001 4.09011 10.08 4.09011 10.225 4.23511C10.295 4.31011 10.335 4.40511 10.335 4.50011Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretDown);
export default __webpack_public_path__ + "static/media/CaretDown.8315384fa6db4de894743f3ed909658a.svg";
export { ForwardRef as ReactComponent };